import type { TranslationType } from '@atpoint/atpjs/helpers/i18n'
import type { ValueType } from '@atpoint/atpjs/validation'
import { predicate, withMessageFn } from '@atpoint/atpjs/validation/functions'
import { isEmpty, isExisty, reportError } from '@atpoint/atpjs/validation/validators'
import { isValid } from 'swisscard/helpers/iban'

export const swissIban = (errorMessage: TranslationType) => {
  return withMessageFn(
    predicate((v: ValueType) => typeof v === 'string' && isExisty(v) && !isEmpty(v) && isValid(v)),
    (value: string) => reportError({ value }, errorMessage),
  )
}
